var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "86AE3E84-778E-4F94-B71C-436C598DB750") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/24x24/print-white"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "frame",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,9 C4.34,9 3,10.34 3,12 L3,18 L7,18 L7,20 L17,20 L17,18 L21,18 L21,12 C21,10.34 19.66,9 18,9 L6,9 Z M8,19 L8,16 L16,16 L16,19 L8,19 Z M17,12 C17,11.45 17.45,11 18,11 C18.55,11 19,11.45 19,12 C19,12.55 18.55,13 18,13 C17.45,13 17,12.55 17,12 Z M7,4 L7,8 L17,8 L17,4 L7,4 Z",
    id: "icon",
    fill: "#FFFFFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintWhite);
export default __webpack_public_path__ + "static/media/print-white.6cb30a8d08aa175891accfb0d47a52af.svg";
export { ForwardRef as ReactComponent };